import { Alert } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';

const ErrorAlert = () => {
  return (
    <Alert
      type='error'
      message='Please correct errors in shipment data'
      showIcon
      style={{
        fontSize: 14,
        fontWeight: 400,
        backgroundColor: 'var(--danger-thin)',
        color: 'var(--danger)',
        border: 'none',
        margin: '10px 0px',
        padding: '12px 16px',
      }}
      icon={
        <ExclamationCircleFilled
          style={{ color: '#D32F2F', fontSize: 20, paddingRight: 15 }}
        />
      }
    />
  );
};

export default ErrorAlert;
